import React from 'react';
import useSinglePageIntro from '../custom-hooks/useSinglePageIntro';
import { Helmet, HelmetProvider } from 'react-helmet-async';

function PageIntro (props) {
  const page = props.pageTitle;
  const output = props.output;
  // console.log('page = ', page);
  const [pageIntro, isLoading] = useSinglePageIntro(page);
  // const [pageIntros, isLoading] = usePageIntros(page);
  // return <h1>Page Title = {props.pageTitle}</h1>;
  if (isLoading === true) {
    return <p>Loading...</p>;
  }
  // console.log("pageIntro = ", pageIntro);

  if (output === "intro") {
    return (
      <div className="introText">
        {/* {ReactHtmlParser(outputHTML)} */}
        {pageIntro.fields.blurbText}
      </div>
    );
  }
  else if (output === "meta") {
    return (
      <HelmetProvider>
      <Helmet>
        <meta name="keywords" content={pageIntro.fields.keywords} />
        <meta name="description" content={pageIntro.fields.metaDescription} />
        <meta name="title" content={page} />
        <title>{page} - Siso Solutions</title>
      </Helmet>
      </HelmetProvider>
    )
  }
}

export default PageIntro;
